import React, { useState } from 'react';
import { Modal } from 'reactstrap';
import _ from 'lodash'
import Actions from '../../../../appFlux/action'
import TabSwitch from '../../../../common/TabSwitch'
import Paginator from '../../../../common/Paginator'
import DateInput from '../../../../common/DateInput'
import DatePicker from "react-datepicker";

class EditMyEduModal extends React.Component {
    constructor(props) {
        super(props);
        var { modal, toggle, extracurriculars } = props
        this.state = {
            extracurriculars: _.cloneDeep(extracurriculars),
            index: extracurriculars.length > 0 ? 0 : undefined,
            pseudoIndex: extracurriculars.length > 0 ? 0 : undefined,
            inputCurricular: "",
        }
    }

    componentWillRecieveProps(props){
        var { modal, toggle, extracurriculars } = props
        console.log("I AM TRIGGERED.....................")
        this.setState({
            extracurriculars: _.cloneDeep(extracurriculars),
            index: extracurriculars.length > 0 ? 0 : undefined,
            inputCurricular: "",
        })
    }

    setIndex = (pseudoIndex) => {
        this.setState({ pseudoIndex })
    }

    setCurricular = (value, param) => {
        var { extracurriculars, index } = this.state
        extracurriculars[index][param] = value
        this.setState({extracurriculars})
    }

    addCurricular = (overrideInput) => {
        var { extracurriculars, inputCurricular, index } = this.state
        var newCurriculars = {
            interest: overrideInput && overrideInput.interest ? overrideInput.interest : inputCurricular,
            description: '',
            date: undefined,
            association: '',
            relation: '',
            city: '',
            country: '',
        }
        extracurriculars.push(newCurriculars)
        index = extracurriculars.length - 1
        this.setState({extracurriculars, index})
    }

    setTab = (label) => {
        var { extracurriculars } = this.state
        extracurriculars.forEach((extracurricular, index) => {
            if(extracurricular.interest === label){
                this.setState({index, pseudoIndex: 0})
            }
        })
    }

    reset = () => this.setState({extracurriculars: _.cloneDeep(this.props.extracurriculars)})
    save = () => {
        Actions.setExtracurriculars(this.state.extracurriculars)
        this.props.toggle()
    }

    render() {
        var { modal, toggle, extracurriculars } = this.props
        var { extracurriculars, inputCurricular, index, pseudoIndex } = this.state
        var selectedCur = index !== undefined ? extracurriculars[index] : undefined
        var tabs = _.uniqBy(extracurriculars, "interest").map(o => {
            return {value: o.interest, label: o.interest}
        })
        var selectedTab = tabs && selectedCur ? tabs.filter((o) => selectedCur.interest === o.value)[0] : undefined
        var categoryItems = selectedTab ? extracurriculars.filter(o => o.interest === selectedTab.label) : []
        selectedCur = selectedTab ? categoryItems[pseudoIndex] : {}
        return (
        <Modal isOpen={modal} toggle={toggle} className="modal-wrap wd-850">        
            <div className="pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
                <div className="modal-header">Edit Extracurricular Interests</div>
                <div className="v-align f-right" style={{marginLeft:'auto'}}>
                    <i className="fa fa-cog modal-close mg-r-15" ></i> 
                    <i className="far fa-question-circle modal-close mg-r-15" ></i>
                    <i className="fas fa-times modal-close" onClick={toggle}></i>
                </div>
            </div>   
            <hr className="mg-r-0"></hr>
            <div className="modal-block">
                <div className="modal-subheader">Add an Interest</div>            
                <div className="row">
                    <div className="col-md-6">
                        <input value={inputCurricular} onChange={(e) => this.setState({ inputCurricular: e.target.value })} type="text" className="form-control"></input>
                    </div>
                    <div className="col-md-6">
                        <button onClick={this.addCurricular} className="btn btn-primary">
                            <i className="fas fa-plus mg-r-5"></i>Add Interest
                        </button>
                    </div>
                </div>
            </div>
            <hr className="mg-0"></hr>
                <div className="row">
                    <div className="wd-pct-23 b-r-border pd-l-25 pd-t-15 pd-r-5">
                        <ul className="nav nav-left-tabs md-tabs tabs-left">
                            <div className="col-md-12">
                                <div className="row">
                                    {tabs.map((tab, i) => (
                                        <TabSwitch
                                            key={tab.label}
                                            idx={tab.label}
                                            title={tab.label}
                                            isActive={tab.label === selectedTab.label}
                                            handleOnClick={this.setTab}
                                         />
                                    ))}
                                </div> 
                            </div> 
                        </ul>
                    </div>
                    <div className="wd-pct-77 pd-t-15 pd-r-25 pd-l-15 pd-b-15">
                    <div >
                        <div className="modal-subheader">Description/Genre of Interest</div>                
                        <div className="mg-b-15"><input value={selectedCur.description} onChange={(e) => this.setCurricular(e.target.value, "description")} type="text" className="form-control"></input></div>
                        <div className="mg-b-5 mg-t-15">
                        <div className="row">
                            <div className="col-md-7">
                            <div className="modal-subheader">Issuer</div>                
                            <div className="mg-b-15"><input value={selectedCur.association} onChange={(e) => this.setCurricular(e.target.value, "association")} type="text" className="form-control"></input></div>
                            </div>
                            <div className="col-md-5">
                            <div className="modal-subheader">Date of Issue (Month/Year)</div>
                                <DatePicker
                                    selected={selectedCur.date}
                                    onChange={(e) => this.setCurricular(e, "date")}
                                    customInput={<DateInput/>}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />
                            </div>
                        </div>
                        <div className="modal-subheader">Location</div>
                        <div className="row mg-b-15">
                            <div className="col-md-6">   
                            <div className="modal-sublistheader mg-t-0">City/State</div>
                            <div><input value={selectedCur.city} onChange={(e) => this.setCurricular(e.target.value, "city")} type="text" className="form-control"></input></div> 
                            </div>
                            <div className="col-md-6">
                            <div className="modal-sublistheader mg-t-0">Country</div>
                            <div><input value={selectedCur.country} onChange={(e) => this.setCurricular(e.target.value, "country")} type="text" className="form-control"></input></div>
                            </div>   
                        </div>  
                        <div className="row mg-t-15">
                                <div className="col-md-8">
                                    <button className="btn btn-mini btn-primary mg-r-25">
                                        <i className="fas fa-info mg-r-5"></i>Upload Honours
                                    </button>                        
                                    <i className="fas fa-certificate text-c-success mg-r-10 c-pointer"></i>
                                    <i className="fas fa-certificate text-c-success mg-r-10 c-pointer"></i>
                                    <i className="fas fa-photo-video text-c-warning c-pointer"></i>
                                </div>
                                <div className="col-md-4">
                                <div className="row f-right mg-r-5">
                                    <div>
                                        <i className="far fa-question-circle text-c-primary-active c-pointer mg-r-5 "></i>
                                    </div>
                                    <div className="text-small-primary">Supported documents</div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="v-align">
                            <div className="wd-pct-33">
                                <Paginator index={pseudoIndex} length={categoryItems.length} onClick={this.setIndex}/>
                            </div>
                            <div className="wd-pct-33 text-center">{"Showing " + (pseudoIndex + 1) + " of " + categoryItems.length}</div>
                            <div style={{marginLeft:'auto'}}>
                                <button className="btn btn-mini btn-default"  onClick={() => this.addCurricular(selectedCur)}>
                                    <i className="fas fa-plus mg-r-5"></i>Add Another
                                </button>
                            </div>
                        </div>
                </div>   
                    </div>
                </div>
            <hr className="mg-0 "></hr>
            <div className="pd-20 box-shadow-top">
                <button className="btn btn-danger-lite f-right " onClick={toggle}>Cancel</button> 
                <button className="btn btn-primary-lite f-right mg-r-15" onClick={this.save}>Save</button>
                <button className="btn btn-success-lite mg-r-15 f-right" onClick={this.reset}>Reset</button>   
            </div>
        </Modal>
        )
    }
}
export default EditMyEduModal;